module.exports = __webpack_public_path__ + "img/canton-logo-fr.fce65c07.svg";